import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { HistoryTiming } from "@faire/web--source/common/performance/HistoryTiming";
import { ActionName } from "@faire/web--source/common/performance/userPerceivedLoadTiming/types";
import { trackInfraProductTilesLoadTimeView } from "@faire/web-api--source/events/infra/view/productTilesLoadTime";
import React, { useEffect } from "react";

export const ProductTileLoadTimePerformanceTracking = ({
  name,
  isRsc,
}: {
  name: ActionName;
  isRsc: boolean;
}) => {
  useEffect(() => {
    if (
      HistoryTiming.get().isInitialLoad &&
      !getGlobalProperty("didTrackProductTilePrehydrationLoad")
    ) {
      runPerfTrackingEffect(name, isRsc);
    }
  }, [name, isRsc]);

  /* This only does anything if the page is server rendered. It has no effect on the client. */
  return (
    <script
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: getPerfTrackingScript(name, isRsc),
      }}
    />
  );
};

// CAREFUL! These two implementations need to match exactly.
// The first one is run in server-rendered contexts and the second one is run in client-rendered contexts.
const getPerfTrackingScript = (name: ActionName, isRsc: boolean) => `
  if (!window.didTrackProductTilePrehydrationLoad && ${isRsc}) {
    window.didTrackProductTilePrehydrationLoad = true;
    Promise.all(
      [...document.querySelectorAll("[data-product-image]")].map(
        (img) =>
          new Promise((ready) => {
            if (img.complete) {
              ready();
            } else {
              img.addEventListener("load", () => {
                ready();
              });
            }
          })
      )
    ).then(() => {
      trackEvent("infra-product_tiles_load_time-view", [
        "${name}",
        ${isRsc ? '"true"' : '"false"'},
        String(performance.now())]);
    });
  }
`;

const runPerfTrackingEffect = (name: string, isRsc: boolean) => {
  Promise.all(
    [...getDocumentOrThrow().querySelectorAll("[data-product-image]")].map(
      (img) =>
        new Promise<void>((ready) => {
          if ((img as HTMLImageElement).complete) {
            ready();
          } else {
            img.addEventListener("load", () => {
              ready();
            });
          }
        })
    )
  ).then(() => {
    trackInfraProductTilesLoadTimeView(
      name,
      isRsc ? "true" : "false",
      String(performance.now())
    );
  });
};
